export class GridFilterModel {
  clientId: number = 0; 
  userId: string = "";
  clientCode: string = "";
  fromDate: Date = null;
  toDate: Date = null;
  skip: number = 0;
  pageSize: number = 0; 
  pageNo: number = 0; 
  isAdmin: boolean = false;
  sqlSortString:string = "";
  sqlFilterString:string = "";
  userRoles: string = "";
  userEmail: string = "";
  formId: string = "";
  sqlGlobalFilterString: string = "";
}
